<template>
  <div class="main-content">
    <div class="layout-px-spacing">
      <div class="row layout-top-spacing">
        <div class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
          <div class="text-right">
            <button
              type="button"
              class="btn btn-primary mb-2 mr-2"
              data-toggle="modal"
              data-target="#searchModal"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>

          <div class="widget-content widget-content-area br-6">
            <div v-if="loading">
              <b-skeleton-table
                :rows="10"
                :columns="5"
                :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </div>

            <div v-else class="table-responsive mb-4 mt-4">
              <table
                id="incident_reports"
                class="table table-hover non-hover"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Title</th>
                    <th>Category</th>
                    <th>Description</th>
                    <th>Department(s) to handle</th>
                    <th>Recommendation</th>
                    <th>Date to revisit</th>
                    <th>Created by</th>
                    <th>Time</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(incident, index) in incidents" :key="incident.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ truncate(incident.title) }}</td>
                    <td>
                      <b-badge
                        variant="success"
                        v-if="incident.category == 'sponsor'"
                      >
                        Sponsor
                      </b-badge>
                      <b-badge
                        variant="info"
                        v-if="incident.category == 'doctor'"
                      >
                        Doctor
                      </b-badge>
                      <b-badge
                        variant="secondary"
                        v-if="incident.category == 'elderly'"
                      >
                        Elderly
                      </b-badge>
                      <b-badge
                        variant="dark"
                        v-if="incident.category == 'other'"
                      >
                        Other
                      </b-badge>
                    </td>
                    <td>{{ truncate(incident.description) }}</td>
                    <td>{{ incident.dept_to_handle }}</td>
                    <td>{{ truncate(incident.recommendation) }}</td>
                    <td>
                      <span v-if="incident.date_to_revisit != null">{{
                        formatDate(incident.date_to_revisit)
                      }}</span>
                    </td>
                    <td>
                      {{
                        incident.user
                          ? `${incident.user.firstname} ${incident.user.lastname}`
                          : ""
                      }}
                    </td>
                    <td>{{ formatDate(incident.created_at) }}</td>
                    <td>
                      <b-badge
                        variant="success"
                        v-if="incident.status == 'resolved'"
                      >
                        Resolved
                      </b-badge>
                      <b-badge
                        variant="danger"
                        v-if="incident.status == 'unresolved'"
                      >
                        Unresolved
                      </b-badge>
                    </td>
                    <td>
                      <div class="btn-group">
                        <router-link
                          :to="`/incidents/view/${incident.id}`"
                          class="btn btn-success btn-sm m-1"
                        >
                          <i class="fa fa-eye"></i>
                        </router-link>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Search Modal -->
      <div
        class="modal fade"
        id="searchModal"
        role="dialog"
        aria-labelledby="searchModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="searchModalLabel">Search Options</h5>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="dateSearch">Date Search</label>
                    <select
                      class="form-control"
                      v-model="search"
                      id="dateSearch"
                    >
                      <option value="all">All</option>
                      <option value="thisweek">This Week (From Monday)</option>
                      <option value="pastweek">Past Week (Last 7 days)</option>
                      <option value="lastmonth">Last Month</option>
                      <option value="thismonth">This Month</option>
                      <option value="thisyear">This Year</option>
                      <option value="custom">Custom</option>
                    </select>
                  </div>

                  <div class="form-group" v-if="search == 'custom'">
                    <label>Select a range</label>
                    <div class="input-group">
                      <flat-pickr
                        v-model="date"
                        :config="config"
                        class="form-control"
                        placeholder="Select date"
                        @on-close="handlePicker()"
                        name="date"
                      >
                      </flat-pickr>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn" data-dismiss="modal">
                <i class="flaticon-cancel-12"></i> Discard
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="handleSearch()"
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import { http } from "@/utils/http";
import { endpoints } from "@/utils/endpoints";
import { mapGetters } from "vuex";
import { DatePickerConfig } from "@/models/datepicker.js";

export default {
  name: "AllIncidents",
  components: {},

  data() {
    return {
      loading: true,
      loadingDelete: false,

      toDelete: "",

      search: "thismonth",
      incidents: {},

      date: null,
      config: new DatePickerConfig(),
      customStart: "",
      customEnd: "",
    };
  },

  computed: {
    ...mapGetters(["url", "user"]),
  },

  mounted() {
    this.fetchRecords();
  },

  methods: {
    initTable() {
      var dt = $("#incident_reports").DataTable({
        retrieve: true,
        dom: "Bfrtip",
        stateSave: true,
        colReorder: true,
        buttons: [
          {
            extend: "copyHtml5",
            text: 'Copy <i class="fa fa-clone"></i>',
            exportOptions: {
              columns: ":visible",
            },
          },
          {
            extend: "excelHtml5",
            text: 'Excel <i class="fa fa-file-excel"></i>',
            exportOptions: {
              columns: ":visible",
            },
          },
          {
            extend: "pdfHtml5",
            text: 'PDF <i class="fa fa-file-pdf"></i>',
            exportOptions: {
              columns: ":visible",
            },
          },
          {
            extend: "print",
            text: 'Print <i class="fa fa-print"></i>',
            exportOptions: {
              columns: ":visible",
            },
          },
          "colvis",
        ],
        select: true,
      });
      dt.columns([5, 6]).visible(false);
    },

    handlePicker() {
      setTimeout(() => {
        if (this.date.length < 15) {
          this.$toast.error("Enter a valid date range");
        } else {
          var split = this.date.split(" ");
          this.customStart = split[0];
          this.customEnd = split[2];
        }
      }, 500);
    },

    handleSearch() {
      if (
        this.search == "custom" &&
        (this.customStart == "" || this.customEnd == "")
      ) {
        this.$toast.error("Enter a valid date range");
      } else {
        this.fetchRecords();
        $("#searchModal").modal("hide");
      }
    },

    fetchRecords() {
      this.loading = true;
      http
        .get(endpoints.GET_ALL_INCIDENTS, {
          params: {
            search: this.search,
            customStart: this.customStart,
            customEnd: this.customEnd,
          },
        })
        .then((response) => {
          this.incidents = response;
          this.loading = false;
          setTimeout(() => {
            this.initTable();
          }, 1000);
        })
        .catch((error) => {
          this.$toast.error(
            error.response?.data?.message || error.response?.message
          );
        });
    },

    roundUp(x) {
      return x.toPrecision(2);
    },

    truncate(x) {
      return _.truncate(x, {
        length: 50,
        separator: " ",
      });
    },
  },
};
</script>
